import React from "react";
import { Checkbox, Table, Modal, Tooltip, Typography } from "antd";
import { AiOutlineClose } from "react-icons/ai";
import { MdOutlineArrowOutward } from "react-icons/md";

import PrimaryButton from "../Forms/PrimaryButton";
import { orderStatus } from "../../constant";
import { roundDecimal } from "../../utils";
import DataTable from "../Tables/Datatable";

const { Title } = Typography;

export default function ViewAllCases({
    open,
    onClose,
    title = "All Case Nos.",
    width = 620,
    orderData,
}) {
    const data = orderData?.items
    const dataItem = data?.filter(item => item?.in_stock == 1)

    const columns = [
        {
            title: "Quality Name",
            dataIndex: "short_name",
            ellipsis: true,
            onCell: () => ({
                style: {
                    verticalAlign: 'top',
                },
            }),
        },
        {
            title: "Shade",
            dataIndex: "shade_name",
            ellipsis: true,
            onCell: () => ({
                style: {
                    verticalAlign: 'top',
                },
            }),
        },
        {
            title: "Quantity",
            dataIndex: "cases",
            onCell: () => ({
                style: {
                    verticalAlign: 'top',
                },
            }),
            ellipsis: true,
            render: (_, record) =>
                `${record.update_total_cases || record.cases || "0"} cases (
          ${roundDecimal(record.update_total_meter || record.quantity_meters || "0")}m)`,
        },

        {
            title: "Case Nos.",
            dataIndex: "cases_no",
            onCell: () => ({
                style: {
                    verticalAlign: 'top',
                },
            }),
            render: (_, record) => (
                <>
                    {record.cases_no && (
                        <div>
                            {record.cases_no.split(',').map(item => (
                                <>
                                    <div>{item}</div></>
                            ))}

                        </div>
                    )}

                </>
            )
        },
    ];

    return (
        <Modal
            className="form-css-2 custom-modal status-modal"
            open={open}
            footer={null}
            onCancel={onClose}
            centered
            width={width}
        >
            {/* Header */}
            <div className="flex flex-col justify-between">
                <Title level={2} className="text-lg font-semibold text-black !m-0 font-abhaya text-left">
                    {title}
                </Title>

                {data?.length > 0 && (
                    <>
                        <Table
                            rowKey="order_item_id"
                            columns={columns}
                            dataSource={dataItem}
                            pagination={false}
                            size="middle"
                            className="mb-3"
                            rootClassName="transparent-table"
                        />
                    </>
                )}
            </div>
        </Modal>
    );
}
